import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'stadium360-logo',
  templateUrl: './stadium360-logo.component.html',
  styleUrls: ['./stadium360-logo.component.scss']
})
export class Stadium360LogoComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
